import React, { useEffect, useState } from "react";
import "./AddInterview.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import {
  getallcategory,
  addsubcategorylist,
  addfaqs,
} from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};

  if (!values.que) {
    errors.que = "Required";
  }
  if (!values.ans) {
    errors.ans = "Required";
  }
  return errors;
};

const Addfaqs = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [cat, setcat] = useState([]);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      que: "",
      ans: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addfaqs(values.que, values.ans);
      navigate("/FAQS_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add FAQ</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Question</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="que"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.que}
              className="Auth_input"
            />
            {formik.errors.que ? (
              <p className="invalid">{formik.errors.que} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Answer</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="ans"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.ans}
              className="Auth_input"
            />
            {formik.errors.ans ? (
              <p className="invalid">{formik.errors.ans} </p>
            ) : null}
          </div>
          <div />
          <div />
          <button className="term_button" type="Submit">
            {load ? "Adding..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Addfaqs;
